angular.module('admin.directives')

  .directive('facebookShareButton', [function(){
    return {
      restrict: 'A',
      controllerAs: 'fbCtrl',
      bindToController: {
        agentId: '@',
        questionType: '@',
      },
      scope: {},
      templateUrl: '/admin/templates/partials/facebook-share-button.html',

      controller: function(){
        let ctrl = this;

        ctrl.shareUrl = `https://get.homebot.ai/?agentId=${ctrl.agentId}&type=${ctrl.questionType}`;

        ctrl.share = function(){
          FB.ui({
            method: 'share',
            href: ctrl.shareUrl,
            mobile_iframe: true,
          }, function(response){ });
        }
      }
    }

  }]);
